import { withStyles } from '@material-ui/core/styles';
import { Switch } from "@material-ui/core";


const AntSwitch = withStyles((theme) => ({
    root: {
        width: 14,
        height: 8,
        padding: 0,
        margin: "0 10px 0 0",
        display: 'flex',
    },
    switchBase: {
        padding: "1px !important",
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(6px) !important',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: "6px !important",
        height: "6px !important",
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

export default AntSwitch;